<template>
  <BaseClearButton v-bind="$attrs" class="opacity-70" size="small" color="white" @click="present"
    >Terms and Conditions</BaseClearButton
  >
  <IonModal ref="modal">
    <IonHeader>
      <IonToolbar color="white">
        <IonTitle color="medium">Terms and Conditions</IonTitle>
        <IonButtons slot="end">
          <IconButton @click="dismiss" icon="icon-x" />
        </IonButtons>
      </IonToolbar>
    </IonHeader>
    <IonContent>
      <div class="p-4 mb-6">
        <p class="font-thin text-xs">
          Please read these Terms and Conditions ("Terms") carefully before using the Next Meters mobile application
          (the "Service") operated by Next Meters ("us", "we", or "our"). Your access to and use of the Service is
          conditioned upon your acceptance of and compliance with these Terms, our Privacy Policy, and any applicable
          app store terms. By accessing or using the Service, you agree to be bound by these Terms. If you disagree with
          any part of the Terms, including the mandatory arbitration provision and class action waiver, you may not
          access or use the Service.
        </p>
        <div class="text-xs mt-2 mb-1">1. Accounts</div>
        <p class="font-thin text-xs">
          You must be at least 18 years of age to create an account. You agree to provide accurate, current, and
          complete information. Failure to do so may result in account termination. You are responsible for maintaining
          the confidentiality of your credentials and all activities under your account. Notify us immediately of any
          unauthorized use. The Service may access features of your mobile device (e.g., GPS, camera) and collect
          metadata (location, device type, OS) and diagnostics. The Service may also gather information from nearby
          devices and transmit that data to our servers.
        </p>
        <div class="text-xs mt-2 mb-1">2. License Grant</div>
        <p class="font-thin text-xs">
          We grant you a limited, non-exclusive, non-transferable, revocable license to download, install, and use the
          Service solely for personal, non-commercial use, in accordance with these Terms. You may not copy, modify,
          reverse engineer, decompile, disassemble, or create derivative works based on the Service.
        </p>
        <div class="text-xs mt-2 mb-1">3. Intellectual Property</div>
        <p class="font-thin text-xs">
          The Service and its original content, features, and functionality are the property of Next Meters and its
          licensors, protected by intellectual property laws. Our trademarks and trade dress may not be used without our
          prior written consent.
        </p>
        <div class="text-xs mt-2 mb-1">4. Privacy</div>
        <p class="font-thin text-xs">
          Our Privacy Policy describes how we collect, use, and share your personal data and is hereby incorporated by
          reference. By using the Service, you consent to the collection and use of your data as described. The Privacy
          Policy can be found at:
          <a class="text-blue-500" href="https://privacy-policy.nextcenturymeters.com/"
            >privacy-policy.nextcenturymeters.com</a
          >.
        </p>
        <div class="text-xs mt-2 mb-1">5. Children</div>
        <p class="font-thin text-xs">
          The Service is not intended for individuals under the age of 13. We do not knowingly collect personal
          information from children under 13. If we learn that we have collected such information, we will take steps to
          delete it.
        </p>
        <div class="text-xs mt-2 mb-1">6. App Store Disclaimers</div>
        <p class="font-thin text-xs">
          These Terms are between you and Next Meters, not Apple Inc. or Google LLC. Apple and Google are not
          responsible for the Service or its content. You agree to comply with their applicable terms. Apple and Google
          have no obligation to furnish support or maintenance services.
        </p>
        <div class="text-xs mt-2 mb-1">7. Links to Third-Party Websites</div>
        <p class="font-thin text-xs">
          The Service may contain links to third-party websites or services. We are not responsible for the content,
          privacy policies, or practices of any third-party websites or services. We encourage you to read their terms
          and privacy policies.
        </p>
        <div class="text-xs mt-2 mb-1">8. Termination</div>
        <p class="font-thin text-xs">
          We may terminate or suspend your account without notice for any breach of these Terms. Upon termination, your
          right to use the Service will cease immediately. Provisions that by their nature should survive termination
          shall do so.
        </p>
        <div class="text-xs mt-2 mb-1">9. Indemnification</div>
        <p class="font-thin text-xs">
          You agree to indemnify and hold harmless Next Meters, its affiliates, and their personnel from any claims,
          liabilities, damages, or expenses arising out of your use of the Service or your violation of these Terms.
        </p>
        <div class="text-xs mt-2 mb-1">10. Limitation of Liability</div>
        <p class="font-thin text-xs">
          In no event shall Next Meters, nor its directors, employees, partners, agents, suppliers, or affiliates, be
          liable for any indirect, incidental, special, consequential or punitive damages, including without limitation,
          loss of profits, data, use, goodwill, or other intangible losses, resulting from (i) your access to or use of
          or inability to access or use the Service; (ii) any conduct or content of any third party on the Service;
          (iii) any content obtained from the Service; and (iv) unauthorized access, use or alteration of your
          transmissions or content, whether based on warranty, contract, tort (including negligence) or any other legal
          theory, whether or not we have been informed of the possibility of such damage, and even if a remedy set forth
          herein is found to have failed of its essential purpose.
        </p>
        <div class="text-xs mt-2 mb-1">11. Disclaimer of Warranties</div>
        <p class="font-thin text-xs">
          The Service is provided "AS IS" and "AS AVAILABLE" without warranties of any kind. We do not warrant that the
          Service will be uninterrupted or error-free or that any defects will be corrected. The Service is provided
          without warranties of any kind, whether express or implied, including, but not limited to, implied warranties
          of merchantability, fitness for a particular purpose, non-infringement or course of performance. Next Meters
          its subsidiaries, affiliates, and its licensors do not warrant that a) the Service will function
          uninterrupted, secure or available at any particular time or location; b) any errors or defects will be
          corrected; c) the Service is free of viruses or other harmful components; or d) the results of using the
          Service will meet your requirements.
        </p>
        <div class="text-xs mt-2 mb-1">12.Exclusions</div>
        <p class="font-thin text-xs">
          Some jurisdictions do not allow certain exclusions or limitations. If applicable law prohibits certain
          disclaimers or limitations, they may not apply to you.
        </p>
        <div class="text-xs mt-2 mb-1">13. Governing Law</div>
        <p class="font-thin text-xs">
          These Terms shall be governed by the laws of the State of Florida, without regard to conflict of law
          principles. If any provision is deemed unenforceable, the remaining provisions shall remain in full force and
          effect.
        </p>
        <div class="text-xs mt-2 mb-1">14. Dispute Resolution and Arbitration</div>
        <p class="font-thin text-xs">
          a. Initial Dispute Resolution: You agree to first contact us to attempt informal resolution.
        </p>
        <p class="font-thin text-xs">
          b. Binding Arbitration: Any dispute shall be resolved by binding arbitration under the rules of the American
          Arbitration Association. Arbitration will be held in Florida before a single arbitrator. No class actions or
          consolidated claims are permitted.
        </p>
        <p class="font-thin text-xs">
          c. Procedure: You or we may initiate arbitration if disputes cannot be resolved within 60 days of notice. Each
          party pays its own legal fees. Arbitration shall remain confidential.
        </p>
        <p class="font-thin text-xs">
          d. Exceptions: We may seek injunctive relief for intellectual property or data security matters.
        </p>
        <p class="font-thin text-xs">
          e. Time Limit: You must bring any claim within one (1) year of the event giving rise to the dispute.
        </p>
        <p class="font-thin text-xs">
          f. No Class Actions: There shall be no right or authority for any claims subject to this this arbitration
          clause to be arbitrated on a class action or consolidated basis involving claims brought in a purported
          representative capacity on behalf of the general public.
        </p>
        <p class="font-thin text-xs">
          g. Fees and Expenses: All fees and expenses of arbitration will be divided equally between you and Next
          Meters. Each party will bear the costs of its own counsel, experts, witnesses, and preparation and
          presentation of evidence at the arbitration hearing.
        </p>
        <div class="text-xs mt-2 mb-1">15. Changes to Terms</div>
        <p class="font-thin text-xs">
          We may revise these Terms at any time, effective immediately upon posting. Continued use after changes
          constitutes acceptance. You are responsible for reviewing the Terms regularly.
        </p>
        <div class="text-xs mt-2 mb-1">Contact Us</div>
        <p class="font-thin text-xs">
          If you have any questions about these Terms, please contact us at
          <a class="text-blue-500" href="mailto:support@nextmeters.com">support@nextmeters.com</a>
        </p>
        <div class="mt-4 mb-3 text-xs font-extralight text-gray-700">Last Modified: May 7, 2025</div>
        <PrimaryBlockButton type="button" @click="dismiss">Close</PrimaryBlockButton>
      </div>
    </IonContent>
  </IonModal>
</template>

<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>
<script setup lang="ts">
import IconButton from '@/components/forms/IconButton.vue';
import { IonModal, IonHeader, IonContent, IonToolbar, IonTitle, IonButtons } from '@ionic/vue';
import PrimaryBlockButton from '@/components/forms/PrimaryBlockButton.vue';
import { ref } from 'vue';
import BaseClearButton from '../forms/BaseClearButton.vue';

const modal = ref<InstanceType<typeof IonModal>>();

function present() {
  modal.value?.$el.present();
}

function dismiss() {
  modal.value?.$el.dismiss();
}

defineExpose({
  present,
  dismiss,
});
</script>
